import { createElement, FC, useContext, useEffect } from 'react';

import { context as StateContext } from '../context/state';
import Screen from '../screen/SignedInScreen';

type Props = {
  className?: string;
};

const SignedInScreen: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [state.location.pathname]);

  return !state.fatalError && state.authentication.fetching === 0 && state.authentication.signedInUser ? (
    <Screen className={className} />
  ) : null;
};

export default SignedInScreen;
